import React from 'react';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';

function CardGroup({register, errors, translations}) {
  return (
    <div className="pt-4">
      <div className="form__group form__group--text text-center mt-4">
        <h2 className="form__title">{translations.secondHeader}</h2>
      </div>

      <div className="input-group form__group col-10 col-sm-9 mx-auto">
        <CardNumberElement placeholder="Card number" className="input string optional"/>
        <span className="input__text text-danger">{errors.form_data_card_number && errors.form_data_card_number.message}</span>
      </div>

      <div className="input-group form__group row col-10 col-sm-9 mx-auto px-0 px-sm-4">
        <div className="col-12 col-sm-7 px-sm-0 pr-sm-3">
          <CardExpiryElement placeholder="MM / YY" className="input string optional"/>
        </div>

        <div className="col-12 col-sm-5 px-sm-0 pl-sm-3">
          <CardCvcElement placeholder="CVC" className="input string optional"/>
        </div>
      </div>

    </div>
  );
};

export default CardGroup;
